var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinWithOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50659 34.0004C8.85989 31.9196 10.7115 30.2098 12.8932 29.0262C15.0749 27.8426 17.5178 27.2227 19.9999 27.2227C22.482 27.2227 24.9248 27.8426 27.1066 29.0262C29.2883 30.2098 31.1399 31.9196 32.4932 34.0004",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.6129C23.9907 23.6129 27.2258 19.6701 27.2258 14.8064C27.2258 9.94278 23.9907 6 20 6C16.0093 6 12.7742 9.94278 12.7742 14.8064C12.7742 19.6701 16.0093 23.6129 20 23.6129Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24512 30.4863C4.98068 29.1396 6.75593 26.4767 9.09607 25.6296",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.748 22.279C10.256 22.4998 9.72037 22.606 9.18139 22.5898C8.6424 22.5735 8.11413 22.4352 7.63636 22.1852C7.15859 21.9352 6.74378 21.58 6.42316 21.1465C6.10254 20.7129 5.88448 20.2122 5.78539 19.6822C5.68631 19.1522 5.70878 18.6065 5.85113 18.0864C5.99347 17.5663 6.25197 17.0853 6.60717 16.6796C6.96236 16.2739 7.40498 15.954 7.90169 15.7442C8.39841 15.5343 8.93627 15.4399 9.47476 15.468",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7544 30.8516C35.0188 29.5049 33.2436 26.842 30.9034 25.9948",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2515 22.279C29.7435 22.4998 30.2791 22.606 30.8181 22.5898C31.3571 22.5735 31.8854 22.4352 32.3631 22.1852C32.8409 21.9352 33.2557 21.58 33.5764 21.1465C33.897 20.7129 34.115 20.2122 34.2141 19.6822C34.3132 19.1522 34.2907 18.6065 34.1484 18.0864C34.006 17.5663 33.7475 17.0853 33.3923 16.6796C33.0372 16.2739 32.5945 15.954 32.0978 15.7442C31.6011 15.5343 31.0632 15.4399 30.5248 15.468",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinWithOthers);
export default __webpack_public_path__ + "static/media/join-with-others.cd8d3413ef19cb7cb01e77b1752c8fce.svg";
export { ForwardRef as ReactComponent };